var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-typography",class:{ 'is-loading': _vm.loading },attrs:{"id":"app"}},[_c('router-view',{staticClass:"o-page o-page--no-footer"}),_c('ui-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }